import dietitianImage from './emin.jpeg';

const About = () => {
    return ( 
        <div className="container">
            <div className='about'>
            <h2>Diyetisyen Mehmet Emin Tatlılıoğlu</h2>
            <img src={dietitianImage} alt="" />
            <p>Lorem ipsum dolor, sit amet consectetur adipisicing elit. Quos recusandae eos dolores id, numquam labore maxime aperiam sint aut earum laboriosam quis in a perferendis odio illo voluptatum consequuntur sed et dolor mollitia autem obcaecati eligendi. Mollitia exercitationem iure cum maxime ex maiores facilis voluptate voluptatum laborum ad qui, dolores in labore cupiditate error sint necessitatibus magnam veritatis perferendis reprehenderit quo quia suscipit deleniti. Dolorum sit consequatur fugit eos similique repellendus quos. Hic repudiandae placeat molestias id libero nulla sint corrupti veniam perspiciatis labore dolorem corporis quisquam sit numquam debitis voluptatem, exercitationem, obcaecati accusantium rerum ea minus fugit. Illum, quia.</p>
        </div>
        </div>
     );
}
 
export default About;